var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.43341 2H13.4328C15.4326 2 17.0635 3.4 17.0635 5.108V12.892C17.0635 14.607 15.4326 16 13.4165 16H9.42521C7.42549 16 5.78637 14.607 5.78637 12.899V9.539H10.8676L9.55634 10.659C9.31047 10.869 9.31047 11.212 9.55634 11.422C9.67927 11.527 9.84319 11.576 10.0071 11.576C10.1628 11.576 10.3267 11.527 10.4497 11.422L12.8428 9.385C12.9657 9.287 13.0313 9.147 13.0313 9C13.0313 8.86 12.9657 8.72 12.8428 8.622L10.4497 6.585C10.2038 6.375 9.80221 6.375 9.55634 6.585C9.31047 6.795 9.31047 7.138 9.55634 7.348L10.8676 8.461H5.78637V5.115C5.78637 3.4 7.42549 2 9.43341 2ZM1.98413 8.99993C1.98413 8.70593 2.26606 8.46093 2.60437 8.46093H5.78613V9.53893H2.60437C2.26606 9.53893 1.98413 9.30093 1.98413 8.99993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.57fecb05350e2103c0301b286f7f80f5.svg";
export { ForwardRef as ReactComponent };